import {cloneDeep} from 'lodash';

export default {
  methods: {
    excluder(items, fields) {
      let newItems = cloneDeep(items);

      if (!newItems || !fields) {
        return items;
      }

      for (let field of fields) {
        if (newItems.hasOwnProperty(field)) {
          delete newItems[field];
        }
      }

      return newItems;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table-data-excluder.js